<div *ngIf="!busy">

    <div class="row margin-top-8">
        <div class="col-md-4 label">
            API Key:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="apiKey"/>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8">
            <button pButton *ngIf="currentData == null" (click)="connect()" class="p-button-raised accent centered-button"
                    [disabled]="isValid()">
                Connect Coax
            </button>

             <button pButton *ngIf="currentData != null" (click)="update()" class="p-button-raised accent centered-button"
                    [disabled]="isValid()">
                Update
            </button>
        </div>
    </div>

</div>